import React, { useState } from 'react'
import { Admin, Resource } from 'react-admin'
import { createMuiTheme } from '@material-ui/core/styles'
import Amplify from 'aws-amplify'

import authConfig from './auth/config'
import { lightTheme } from './layout/themes'
// import userSaga from './data/sagas/user'
// import userReducer from './data/reducers/user'
import customRoutes from './routes'
import authProvider from './auth/provider'
import { provider as dataProvider } from './data'
import { Layout } from './layout'
import LoginPage from './auth/LoginPage'
import LogoutButton from './auth/LogoutButton'
import Dashboard from './dashboards/main'
import modalities from './modalities'
import accounts from './accounts'
import alerts from './alerts'
import simulators from './simulators'
import reports from './reports'
import agents from './agents'
import users from './users'
import tagTypes from './tag-types'
import tags from './tags'
import { USER_ROLES } from './constants'
import modalitiesTubeAnalysis from './modalities-tube-analysis'
import modalitiesCryogenAnalysis from './modalities-cryogen-analysis'
import modalitiesCapexAnalysis from './modalities-capex-analysis'
import modalitiesMachineLogs from './modalities-machine-logs'
import modalitiesMetrics from './modalities-metrics-dashboard'

import { BrandProvider, useBrand } from './hooks/useBrand'

Amplify.configure(authConfig)
// const theme = createMuiTheme(lightTheme)

const App = () => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')))
  const brand = useBrand()
  const theme = createMuiTheme(brand.theme)

  console.log('BRAND', brand.theme)

  return (
    <Admin
      theme={theme}
      layout={Layout}
      loginPage={LoginPage}
      logoutButton={LogoutButton}
      dashboard={Dashboard}
      customRoutes={customRoutes}
      dataProvider={dataProvider(user && user.accountId)}
      authProvider={authProvider(setUser)}
    >
      {permissions => [
        // Analytics resources - NOT for RAD_TECH
        permissions !== USER_ROLES.RAD_TECH ? (
          <Resource
            name="modalities/tube-analysis"
            {...modalitiesTubeAnalysis}
          />
        ) : null,
        permissions !== USER_ROLES.RAD_TECH ? (
          <Resource
            name="modalities/cryogen-analysis"
            {...modalitiesCryogenAnalysis}
          />
        ) : null,
        permissions !== USER_ROLES.RAD_TECH ? (
          <Resource
            name="modalities/capex-analysis"
            {...modalitiesCapexAnalysis}
          />
        ) : null,
        permissions !== USER_ROLES.RAD_TECH ? (
          <Resource name="modalities/logs" {...modalitiesMachineLogs} />
        ) : null,
        permissions !== USER_ROLES.RAD_TECH ? (
          <Resource name="modalities/metrics" {...modalitiesMetrics} />
        ) : null,
        // Main modalities resource - RAD_TECH gets simplified list with no show/edit/create
        <Resource
          name="modalities"
          list={permissions === USER_ROLES.RAD_TECH ? modalities.radTechList : modalities.list}
          show={permissions === USER_ROLES.RAD_TECH ? null : modalities.show}
          edit={permissions === USER_ROLES.RAD_TECH ? null : modalities.edit}
          create={permissions === USER_ROLES.RAD_TECH ? null : modalities.create}
          icon={modalities.deviceIcon}
        />,
        permissions === USER_ROLES.SUPER_ADMIN ||
        permissions === USER_ROLES.ACCOUNT_ADMIN ? (
          <Resource name="accounts" {...accounts} />
        ) : null,
        permissions === USER_ROLES.SUPER_ADMIN ||
        permissions === USER_ROLES.ACCOUNT_ADMIN ? (
          <Resource name="alerts" {...alerts} />
        ) : null,
        permissions === USER_ROLES.SUPER_ADMIN ||
        permissions === USER_ROLES.ACCOUNT_ADMIN ? (
          <Resource name="reports" {...reports} />
        ) : null,
        permissions === USER_ROLES.SUPER_ADMIN ||
        permissions === USER_ROLES.ACCOUNT_ADMIN ? (
          <Resource name="users" {...users} />
        ) : null,
        permissions === USER_ROLES.SUPER_ADMIN ||
        permissions === USER_ROLES.ACCOUNT_ADMIN ? (
          <Resource name="agents" {...agents} />
        ) : null,
        permissions === USER_ROLES.SUPER_ADMIN ||
        permissions === USER_ROLES.ACCOUNT_ADMIN ? (
          <Resource name="simulators" {...simulators} />
        ) : null,
        permissions === USER_ROLES.SUPER_ADMIN ||
        permissions === USER_ROLES.ACCOUNT_ADMIN ? (
          <Resource name="tag-types" {...tagTypes} />
        ) : (
          // RAD_TECH needs data-only access to tag-types for filtering
          <Resource name="tag-types" />
        ),
        permissions === USER_ROLES.SUPER_ADMIN ||
        permissions === USER_ROLES.ACCOUNT_ADMIN ? (
          <Resource name="tags" {...tags} />
        ) : (
          // RAD_TECH needs data-only access to tags for filtering
          <Resource name="tags" />
        ),
        <Resource name="modalities/types" />,
        <Resource name="simulators/templates" />,
        <Resource name="manufacturers" />,
        <Resource name="vnc/configs" />,
      ]}
    </Admin>
  )
}

const BrandedApp = () => {
  return (
    <BrandProvider>
      <App />
    </BrandProvider>
  )
}

export default BrandedApp
